"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var l = require("lenovo");
var dowCommon = require("./DLM");
var common_1 = require("../../psp_driverlist/src/common");
var severityToolTip_1 = require("../../../../core/src/common/severityToolTip");
var lodash_1 = require("lodash");
var DriverList = /** @class */ (function (_super) {
    __extends(DriverList, _super);
    function DriverList(props) {
        var _this = _super.call(this, props) || this;
        _this.isShowDownloadCart = true;
        _this.descInfo = null;
        _this.state = { showCard: false };
        _this.data = props.data;
        _this.isShowDownloadCart = (common_1.Utils.isMobile() == false && l.Common.isWin7OrAbove(true));
        _this.descInfo = l.Common.getCurrentRealm() === l.RealmType.Dcg && _this.data.AlertDataLoss ? React.createElement("span", { className: "content-desc", style: { paddingLeft: (common_1.Utils.isMobile() == true) ? "0px" : "45px" } }, l.Translator.translate('apply this update prevent data loss|Apply this update to prevent data loss.')) : null;
        return _this;
    }
    DriverList.prototype.Category = function (what) {
        if (this.data.Categories && this.data.Categories.length > 0) {
            return this.data.Categories[0][what];
        }
        else
            return "dl-category-generic";
    };
    DriverList.prototype.componentDidMount = function () {
        var _this = this;
        if (this.isShowDownloadCart) {
            dowCommon.DLMRender(document.getElementById("shoppingcartBox"), function () {
                _this.forceUpdate();
            });
        }
    };
    Object.defineProperty(DriverList.prototype, "DCGFixIDNamingGuideImageUrl", {
        get: function () {
            return window["ds_getcontent"] ? window["ds_getcontent"].DCGFixIDNamingGuideImageUrl : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriverList.prototype, "HasRestrictLock", {
        get: function () {
            var _a = this.data.RestrictCountryList, RestrictCountryList = _a === void 0 ? [] : _a;
            if (!Array.isArray(RestrictCountryList))
                return false;
            // [ESDCG-285] If this product is in warranty, so that the restrict lock will be useless
            if (typeof ds_warranties === 'object' && ds_warranties != null && ds_warranties.Status)
                return false;
            // Because the restrict lock is only for noticing user to enter a useful and in-warranty SN.
            return RestrictCountryList.indexOf(l.CultureUtility.getCurrentCountry()) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    DriverList.prototype.render = function () {
        var _this = this;
        var DisplayDownloadLaterCol = false;
        if (!this.data.Files)
            this.data.Files = [];
        this.data.Files.forEach(function (file, idx) {
            if (l.Common.isWin7OrAbove(true) &&
                !_this.data.RequireLogin &&
                !_this.data.isFirmwareDock &&
                !_this.data.InWarranty
                && !_this.data.PNCheck) {
                DisplayDownloadLaterCol = /http(s?):\/\/download.lenovo.com.*/.test(file.URL.trim()) || DisplayDownloadLaterCol === true ? true : false;
            }
            if (DisplayDownloadLaterCol == true)
                return false;
        });
        this.isShowDownloadCart = this.isShowDownloadCart && DisplayDownloadLaterCol;
        var driverLst = this.data.Files.map(function (file, idx) {
            return React.createElement(DriverItem, { "data-file": file, data: _this.data, DisplayDownloadLaterCol: DisplayDownloadLaterCol });
        });
        var categoryicon = this.Category("Classify") ? this.Category("Classify") : "dl-category-generic";
        var isMobile = common_1.Utils.isMobile();
        var tipscardButton = function () {
            return React.createElement("span", { className: "filename-guide disable-select icon-lenovo-drivers-info-icon", onMouseEnter: function () { _this.setState({ showCard: true }); }, onMouseLeave: function () { _this.setState({ showCard: false }); } }, _this.state.showCard ? React.createElement("div", { className: "tips-card" },
                React.createElement("div", { className: "card" },
                    React.createElement("div", { className: "image" },
                        React.createElement("img", { width: "100%", height: "100%", src: _this.DCGFixIDNamingGuideImageUrl })),
                    React.createElement("div", { className: "link" },
                        React.createElement("a", { target: "_blank", href: "/solutions/HT506035" }, l.Translator.translate("dcg file naming guide document"))),
                    React.createElement("div", { className: "close", style: { visibility: "hidden" } }, "\u00D7")),
                React.createElement("div", { className: "corner" }),
                React.createElement("div", { className: "corner-bg" })) : null);
        };
        return (React.createElement("div", { className: "dow-ds-diver" },
            React.createElement("ul", { className: "dow-list-item dow-ds-title-min-h" },
                React.createElement("li", { className: "col-lg-" + (this.isShowDownloadCart ? '9' : '12') + " col-md-" + (this.isShowDownloadCart ? '8' : '12') + " col-xs-" + (this.isShowDownloadCart ? '7' : '12') + " dow-item-child dow-ds-flex dow-ds-driver-title" },
                    React.createElement("span", { className: categoryicon + " dow-child-icon dow-pull-left" }),
                    React.createElement("span", { className: 'dow-title  dow-pull-left' }, this.data.Title)),
                this.isShowDownloadCart ? React.createElement("li", { className: "col-lg-3 col-md-4 col-xs-5 dow-display-block", id: "shoppingcartBox" }) : null),
            this.descInfo ? React.createElement("div", { className: "dow-ds-content" }, this.descInfo) : null,
            React.createElement("div", { className: "dow-box" },
                isMobile != true ? React.createElement("ul", { className: "dow-list-item dow-list-item-title border-bottom" },
                    React.createElement("li", { className: "col-lg-" + (DisplayDownloadLaterCol ? '3' : '4') + " col-md-" + (DisplayDownloadLaterCol ? '3' : '4') + " col-xs-" + (DisplayDownloadLaterCol ? '3' : '4'), style: { display: "inline-flex" } },
                        l.Translator.translate("individual downloads|Individual Downloads"),
                        " ",
                        l.Common.getCurrentRealm() === l.RealmType.Dcg ? tipscardButton() : null),
                    React.createElement("li", { className: "col-lg-2 col-md-2 col-xs-2  text-" + (l.Common.getCurrentRealm() == l.RealmType.Dcg ? 'left' : 'center') }, l.Translator.translate("operating system for filter|Operating System")),
                    React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1  text-center" }, l.Translator.translate("version|Version")),
                    React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1  text-center" }, l.Translator.translate("released|Released")),
                    React.createElement(severityToolTip_1.default, null,
                        React.createElement("li", { className: "col-lg-2 col-md-2 col-xs-2 text-center" }, l.Translator.translate("severity|Severity"))),
                    React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, l.Translator.translate("Size|Size")),
                    (DisplayDownloadLaterCol) ? React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, l.Translator.translate("Add|Add")) : null,
                    React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, l.Translator.translate("Download|Download"))) : React.createElement("div", { className: "col-lg-12 dow-adup-padding-left-clear dow-ds-gray" }, l.Translator.translate("individual downloads|Individual Downloads")),
                driverLst,
                React.createElement(DS_Part_Content, { data: this.data }))));
    };
    return DriverList;
}(React.Component));
exports.DriverList = DriverList;
var DriverItem = /** @class */ (function (_super) {
    __extends(DriverItem, _super);
    function DriverItem(props) {
        var _this = _super.call(this, props) || this;
        _this.componentWillReceiveProps(props);
        _this.ShowCheckSumClicked = _this.ShowCheckSumClicked.bind(_this);
        _this.state = { IsVisible: false };
        return _this;
    }
    DriverItem.prototype.componentWillReceiveProps = function (props) {
        this.data = props["data"];
        this.dataOs = this.data.OperatingSystemKeys;
        this.file = props["data-file"];
        console.log('date is:' + this.data.Date);
        this.releaseDate = common_1.Utils.driverListDateTime(this.data.Date.Unix);
        this.UnLock = this.UnLock.bind(this);
    };
    DriverItem.prototype.Version = function () {
        if (this.file.Version.length > 12) {
            return (React.createElement("span", null, this.file.Version.substring(0, 12) + "..."));
        }
        else {
            return (React.createElement("span", null, this.file.Version));
        }
    };
    ;
    DriverItem.prototype.Os = function () {
        var os = [];
        if (this.file.OperatingSystemKeys != null && this.file.OperatingSystemKeys.length > 0) {
            this.file.OperatingSystemKeys.forEach(function (o) {
                os.push(React.createElement("span", null,
                    o,
                    React.createElement("br", null)));
            });
        }
        else {
            this.dataOs.forEach(function (o) {
                os.push(React.createElement("span", null,
                    " ",
                    o,
                    React.createElement("br", null)));
            });
        }
        return (React.createElement("div", null, os));
    };
    ;
    DriverItem.prototype.ShowCheckSumClicked = function (e) {
        this.state.IsVisible = !this.state.IsVisible;
        this.setState(this.state);
        l.DTM.push({ type: "eSupportProcess_Complete", name: "DSDownload:Checksum", action: "Button Click" });
    };
    DriverItem.prototype.UnLock = function (event) {
        window["unLock"](event.target);
    };
    Object.defineProperty(DriverItem.prototype, "HasLoginLock", {
        get: function () {
            return (this.data.RequireLogin) && !l.AccountAuthentication.isLogin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriverItem.prototype, "HasWarrantyLock", {
        get: function () {
            return this.data.InWarranty &&
                !((typeof ds_warranties === 'object' &&
                    ds_warranties != null &&
                    ds_warranties.Status) ||
                    this.data.ProductRemainingDays // [ESDCG-674] Add the warranties remainingDays in driver.
                );
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriverItem.prototype, "HasRestrictLock", {
        get: function () {
            var _a = this.data.RestrictCountryList, RestrictCountryList = _a === void 0 ? [] : _a;
            if (!(RestrictCountryList instanceof Array))
                return false;
            // [ESDCG-285] If this product is in warranty, so that the restrict lock will be useless
            if ((typeof ds_warranties === 'object' && ds_warranties != null && ds_warranties.Status) ||
                this.data.ProductRemainingDays // [ESDCG-674] Add the warranties remainingDays in driver.
            ) {
                return false;
            }
            // Because the restrict lock is only for noticing user to enter a useful and in-warranty SN.
            return RestrictCountryList.indexOf(l.CultureUtility.getCurrentCountry()) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriverItem.prototype, "IsPnCheckUnLock", {
        get: function () {
            var result = false;
            if (Cookies.get("PNIsNormal")) {
                var pncheckresult = Cookies.get("PNIsNormal");
                var getSnAndPnCheck = decodeURIComponent(escape(window.atob(pncheckresult)));
                var checkSn = getSnAndPnCheck.split('|')[0];
                var checkPnResult = getSnAndPnCheck.split('|')[1];
                var currentsn = window["config"] && window["config"].product && window["config"].product.Serial ? window["config"].product.Serial : "";
                if (checkPnResult == "true") {
                    result = true;
                }
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriverItem.prototype, "HasPNCheckLock", {
        get: function () {
            var isCheckPN = this.IsPnCheckUnLock;
            var IsOrNoLock = this.data.PNCheck && !isCheckPN;
            return IsOrNoLock;
        },
        enumerable: true,
        configurable: true
    });
    DriverItem.prototype.OnClickDownload = function (fileData) {
        // [MSE-3537]
        // Track for clicking download.
        var url = lodash_1.get(fileData, 'URL', '');
        var type = lodash_1.get(this.data, ['Categories', 0, 'Name'], '');
        common_1.Utils.fileDownloadTrack({ fileName: url, fileType: type });
    };
    DriverItem.prototype.DownloadNow = function () {
        var _this = this;
        // [ESDCG-285] When the rule below is active, don't show any download icon and show the lock icon
        if (l.Common.getCurrentRealm() == l.RealmType.Dcg &&
            this.HasRestrictLock) {
            return (React.createElement("span", { className: "icon-lock dow-lock icon", title: "click and unlock", "data-locktype": "restrict-country", onClick: this.UnLock }));
        }
        if (this.file.URL && this.file.URL.toLowerCase().indexOf('?__token__=') >= 0) {
            if (this.HasLoginLock) {
                return (React.createElement("span", { className: "icon-lock dow-lock icon", title: "click and unlock", "data-locktype": "require-login", onClick: this.UnLock }));
            }
            if (this.HasWarrantyLock) {
                return (React.createElement("span", { className: "icon-lock dow-lock icon", title: "click and unlock", "data-locktype": "in-warranty", onClick: this.UnLock }));
            }
            if (this.HasPNCheckLock) {
                return (React.createElement("span", { className: "icon-lock dow-lock icon", title: "click and unlock", "data-locktype": "require-pncheck", onClick: this.UnLock }));
            }
        }
        var isReadMe = this.file.Name.toLowerCase().indexOf('readme') == 0;
        return (React.createElement("a", { target: "_blank", href: this.file.URL },
            React.createElement("span", { className: "icon-lenovo-drivers-download-directly-icon icon dow-exe-download", onClick: function (e) { return _this.OnClickDownload(_this.file); }, title: isReadMe ? "View Readme.txt File" : "Download File" })));
    };
    ;
    DriverItem.prototype.render = function () {
        var fileName = this.file.Name;
        var pageType = l.Common.getCurrentRealm();
        var isDcgSite = pageType == l.RealmType.Dcg;
        var IsLenovoUrl = this.file.URL ? /http(s?):\/\/download.lenovo.com.*/.test(this.file.URL.trim()) : true;
        var isLenovoLink = this.file.URL ? this.file.URL.trim().indexOf('lenovo.com') > 0 : true;
        var isDcgThirdURL = (isDcgSite && !IsLenovoUrl);
        var isDisplayDesc = isDcgSite && fileName;
        var downloadLater = null;
        if (this.file.URL &&
            !this.data.isFirmwareDock &&
            !this.data.RequireLogin &&
            !this.data.InWarranty &&
            !this.data.PNCheck &&
            IsLenovoUrl) {
            fileName = this.file.URL.split("/").pop();
        }
        if (l.Common.isWin7OrAbove(true) &&
            !this.data.isFirmwareDock &&
            !this.data.RequireLogin &&
            !this.data.InWarranty) {
            // [ESDCG-285] If has restrict country limit, do not show the "download later".
            if (IsLenovoUrl && !(isDcgSite && this.HasRestrictLock && this.HasPNCheckLock)) {
                downloadLater = React.createElement(dowCommon.DownloadLater, { "data-ds": this.data.DocId, "data-file": this.file, "data-driver": this.data, "data-type": dowCommon.DownloadLateType.Single, "data-from": dowCommon.DS_FileFrom.DOWNLOADSDETAILE });
            }
        }
        var isMobile = common_1.Utils.isMobile();
        var IsShowChecksum = this.file.MD5 || this.file.SHA256 || this.file.SHA1;
        var Released = this.file.Released == null ? this.releaseDate : common_1.Utils.driverListDateTime(this.file.Released.Unix);
        var ChecksumTip = React.createElement("li", { name: "ChecksumDiv", style: { display: (this.state.IsVisible == true ? "inline-block" : "none") }, id: this.file.URL, className: "col-lg-12 col-md-12 col-xs-12" },
            React.createElement("div", { className: "row dow-checksum" },
                React.createElement("div", { className: "col-md-12" }, l.Translator.translate("checksum tips|Checksum Tips")),
                React.createElement("div", { className: "col-md-12 checkSumItems" },
                    this.file.MD5 ? React.createElement("p", null,
                        "MD5:",
                        this.file.MD5) : null,
                    this.file.SHA1 ? React.createElement("p", null,
                        "SHA1:",
                        this.file.SHA1) : null,
                    this.file.SHA256 ? React.createElement("p", null,
                        "SHA-256:",
                        this.file.SHA256) : null)));
        var bottomBorder = (this.data.Files[this.data.Files.length - 1]["URL"] == this.file.URL && this.data.Description != null && this.data.Description.trim() == "") ? "" : " border-bottom";
        if (!isMobile) { //PC view
            return (React.createElement("ul", { className: "dow-list-item " + bottomBorder },
                React.createElement("li", { className: "col-lg-" + (this.props.DisplayDownloadLaterCol ? '3' : '4') + " col-md-" + (this.props.DisplayDownloadLaterCol ? '3' : '4') + " col-xs-" + (this.props.DisplayDownloadLaterCol ? '3' : '4') + " " + (isDcgSite ? 'dow-dcg-file-title' : '') },
                    isDcgThirdURL ? React.createElement("a", { target: "_blank", href: this.file.URL }, this.file.URL) : fileName,
                    this.file.Name ? React.createElement("span", { className: "dow-ds-driver-type" },
                        React.createElement("br", null),
                        this.file.Name) : null,
                    (IsShowChecksum) ? React.createElement("br", null) : null,
                    (IsShowChecksum) ? React.createElement("a", { name: "ShowCheckSumData", md5: this.file.URL, className: "dow-show-checksum", data: this.file.URL, onClick: this.ShowCheckSumClicked }, l.Translator.translate("checksum|Checksum")) : null),
                React.createElement("li", { className: "col-lg-2 col-md-2 col-xs-2 text-" + (isDcgSite ? 'left' : 'center') }, this.Os()),
                React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, this.file.Version),
                React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center dow-ds-date" }, Released),
                React.createElement("li", { className: "col-lg-2 col-md-2 col-xs-2 text-center" }, this.file.Priority),
                React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, isDcgThirdURL ? null : this.file.Size),
                (this.props.DisplayDownloadLaterCol) ? React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" }, downloadLater) : null,
                React.createElement("li", { className: "col-lg-1 col-md-1 col-xs-1 text-center" },
                    isDcgThirdURL ? React.createElement("div", null,
                        React.createElement("a", { className: "dow-third-url-icon", href: this.file.URL, target: "_blank", title: (isLenovoLink ? l.Translator.translate("link to lenovo site|This link will take you to a Lenovo site") : l.Translator.translate("hint link to third party site|This link will take you to a 3rd Party site")) }),
                        React.createElement("p", { className: "dow-third-url-tip" }, (isLenovoLink ? l.Translator.translate("lenovo link|Lenovo Link") : l.Translator.translate('third party link|3rd Party Link')))) : this.DownloadNow(),
                    " "),
                IsShowChecksum ? React.createElement("li", { name: "ChecksumDiv", style: { display: (this.state.IsVisible == true ? "inline-block" : "none") }, id: this.file.URL, className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("div", { className: "row dow-checksum" },
                        React.createElement("div", { className: "col-md-12" }, l.Translator.translate("checksum tips|Checksum Tips")),
                        React.createElement("div", { className: "col-md-12 checkSumItems" },
                            this.file.MD5 ? React.createElement("p", null,
                                "MD5:",
                                this.file.MD5) : null,
                            this.file.SHA1 ? React.createElement("p", null,
                                "SHA1:",
                                this.file.SHA1) : null,
                            this.file.SHA256 ? React.createElement("p", null,
                                "SHA-256:",
                                this.file.SHA256) : null))) : null));
        }
        else { //Mobile view
            return (React.createElement("ul", { className: "dow-list-item dow-ds-mobile-item " + bottomBorder },
                React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12 dow-ds-flex" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("downloads|Downloads")),
                    React.createElement("span", { className: "text-left " + (l.Common.getCurrentRealm() == l.RealmType.Dcg ? " dow-ds-mobile-driver-title" : "") },
                        isDcgThirdURL ? React.createElement("a", { target: "_blank", href: this.file.URL }, this.file.URL) : fileName,
                        this.file.TypeString && IsLenovoUrl && (!isDisplayDesc) ? React.createElement("span", { className: "dow-ds-driver-type" },
                            React.createElement("br", null),
                            this.file.TypeString) : null,
                        isDisplayDesc ? React.createElement("span", { className: "dow-ds-driver-type" },
                            React.createElement("br", null),
                            this.file.Name) : null)),
                React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("operating system for filter|Operating System")),
                    this.Os()),
                React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("Version|Version")),
                    React.createElement("span", { className: "text-left" }, this.file.Version)),
                React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("Released|Released")),
                    React.createElement("span", { className: "text-left" }, Released)),
                React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("Severity|Severity")),
                    React.createElement("span", { className: "text-left" }, this.file.Priority)),
                isDcgThirdURL ? null : React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("span", { className: "dow-ds-gray text-left" }, l.Translator.translate("Size|Size")),
                    React.createElement("span", null, this.file.Size)),
                isDcgThirdURL ? null : React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("div", { style: { display: (IsShowChecksum ? "inline-block" : "none") }, className: "text-left dow-checksum-box" },
                        React.createElement("span", { className: "dow-ds-gray marginRight10" }, l.Translator.translate("checksum|Checksum")),
                        React.createElement("a", { className: "icon-checksum", onClick: this.ShowCheckSumClicked })),
                    React.createElement("div", { className: "text-left dow-download-box" },
                        React.createElement("span", { className: "dow-ds-gray marginRight10" }, l.Translator.translate("download|Download")),
                        isDcgThirdURL ? React.createElement("a", { className: "dow-third-url-icon", href: this.file.URL, target: "_blank", title: (isLenovoLink ? l.Translator.translate("link to lenovo site|This link will take you to a Lenovo site") : l.Translator.translate("hint link to third party site|This link will take you to a 3rd Party site.")) }) : this.DownloadNow(),
                        isDcgThirdURL ? React.createElement("span", { className: "dow-third-url-tip-mobile" }, (isLenovoLink ? l.Translator.translate("lenovo link|Lenovo Link") : l.Translator.translate('third party link|3rd Party Link'))) : null)),
                IsShowChecksum ? React.createElement("li", { name: "ChecksumDiv", style: { display: (this.state.IsVisible == true ? "inline-block" : "none") }, id: this.file.URL, className: "col-lg-12 col-md-12 col-xs-12" },
                    React.createElement("div", { className: "row dow-checksum" },
                        React.createElement("div", { className: "col-md-12 dow-tip" }, l.Translator.translate("checksum tips|Checksum Tips")),
                        React.createElement("div", { className: "col-md-12 checkSumItems" },
                            this.file.MD5 ? React.createElement("p", null,
                                React.createElement("span", { className: "dow-ds-gray text-left" }, "MD5"),
                                this.file.MD5) : null,
                            this.file.SHA1 ? React.createElement("p", null,
                                React.createElement("span", { className: "dow-ds-gray text-left" }, "SHA1"),
                                this.file.SHA1) : null,
                            this.file.SHA256 ? React.createElement("p", null,
                                React.createElement("span", { className: "dow-ds-gray text-left" }, "SHA-256"),
                                this.file.SHA256) : null))) : null));
        }
    };
    return DriverItem;
}(React.Component));
var DS_Part_Content = /** @class */ (function (_super) {
    __extends(DS_Part_Content, _super);
    function DS_Part_Content(props) {
        return _super.call(this) || this;
    }
    DS_Part_Content.prototype.render = function () {
        var data = this.props.data;
        if (data.Description && data.Description.trim()) {
            return (React.createElement("ul", { className: "dow-ds-props" },
                React.createElement("li", null,
                    React.createElement("span", { className: "dow-ds-props-title" }, l.Translator.translate("Description|Description")),
                    React.createElement("p", null, data.Description))));
        }
        else
            return null;
    };
    return DS_Part_Content;
}(React.Component));
